import { render, staticRenderFns } from "./EditCompanyServiceModal.vue?vue&type=template&id=4a2df462&"
import script from "./EditCompanyServiceModal.vue?vue&type=script&lang=ts&"
export * from "./EditCompanyServiceModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports